import request from './request'

export function getGoodsDetail(id) {
  return request({
    url: '/goods/detail',
    method: 'get',
    params: { id }
  })
}

export function createNativePrepay(params = {}) {
  return request({
    url: '/api/pay/prepay',
    method: 'post',
    params
  })
}

export function queryNativePayByOutTradeNo(outTradeNo) {
  return request({
    url: `/api/pay/query/by-out-trade-no/${encodeURIComponent(outTradeNo)}`,
    method: 'get'
  })
}
